
import Vue from 'vue';
import _ from 'lodash';
import { convertToArabicNumber } from '@/helpers/convertToArabicNumber';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    lmDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    lmType: function(): string {
      return this.input.config.lmType || 'default';
    },
    customerDetails: function(): any {
      return this.getVariable(this.input.config.customerDetailsVariable);
    },
    customerPo: function(): any {
      return _.get(this.lmDetails, 'orders[0].order.customerPO', 0) || _.get(this.lmDetails, 'callOffs.0.callOff.customerPO', 0);
    },
    quotationId: function(): number {
      return _.get(this.lmDetails, 'callOffs.0.callOff.quotationId', 0);
    },
    addressKey: function(): string {
      return this.input.config.billingAddressKey || 'address';
    },
    deliveryAddressObject: function(): { location: any, ref: string } | undefined {
      const deliveryAlias = _.get(this.lmDetails, this.input.config.deliveryAddressRef, 0);
      return _.find(this.customerDetails.deliveryAddresses, (deliveryAddressObj: any) => deliveryAddressObj.ref == deliveryAlias);
    },
    deliveryAddress: function(): string {
      const deliveryAddress = _.get(this.deliveryAddressObject, 'location.alias_en', '');
      if(deliveryAddress) {
        return deliveryAddress;
      }
      else if(_.get(this.customerDetails, `${this.addressKey}.alias_en`)) {
        return _.get(this.customerDetails, `${this.addressKey}.alias_en`)
      } else {
        return this.getCityAndCountryFromAddress(this.customerDetails[this.addressKey]);
      }
    },
    arabicAddress: function(): string {
      const deliveryAddress = _.get(this.deliveryAddressObject, 'location.alias_ar', '');
      if(deliveryAddress) {
        return deliveryAddress;
      }
      else {
        return _.get(this.customerDetails, `${this.addressKey}.alias_ar`, '');
      }
    }
  },
  methods: {
    getCityAndCountryFromAddress(addressObject: any): string {
      const addressComponents: any[] = _.get(addressObject, 'address_components');
      if(!addressComponents) return '';
      const cityComponent = addressComponents.find((addressComponent: any) => addressComponent.types.includes('locality'));
      const countryComponent = addressComponents.find((addressComponent: any) => addressComponent.types.includes('country'));
      return `${cityComponent.long_name}, ${countryComponent.long_name}`;
    },
    convertToArabicNo: function(numValue: number): string {
      return convertToArabicNumber(numValue);
    },
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
